import { render, staticRenderFns } from "./SwitchButtonComponent.vue?vue&type=template&id=a929a584"
import script from "./SwitchButtonComponent.vue?vue&type=script&lang=js"
export * from "./SwitchButtonComponent.vue?vue&type=script&lang=js"
import style0 from "./SwitchButtonComponent.vue?vue&type=style&index=0&id=a929a584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports